import React from "react";

function SvgAccueil() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
    >
      <path
        d="M6.5 16V10.294C6.5 9.7688 6.94772 9.34303 7.5 9.34303H10.5C11.0523 9.34303 11.5 9.7688 11.5 10.294V16M8.42048 1.17598L1.92048 5.57169C1.65668 5.75009 1.5 6.03888 1.5 6.34671V14.5735C1.5 15.3613 2.17157 16 3 16H15C15.8284 16 16.5 15.3613 16.5 14.5735V6.34671C16.5 6.03888 16.3433 5.75009 16.0795 5.57169L9.57952 1.17598C9.23257 0.941341 8.76744 0.941341 8.42048 1.17598Z"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
      />
    </svg>
  );
}

export default SvgAccueil;
